import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { mq, baseTransitionSecond, easeOut02, isIe } from 'style/variables';
import Img from 'components/atoms/img';
import { FluidObject } from 'gatsby-image';

type ImgMaskProps = {
  filename: string | string[];
  alt: string;
  caption?: string;
  spFullSize?: boolean;
  isCover?: boolean;
  fluid?: FluidObject | FluidObject[];
};

const Container = styled.div`
  position: relative;
  background-color: #f4f4f4;
  overflow: hidden;
  &.is-landscape {
    video {
      width: 100%;
      height: auto !important;
    }
  }
  &:not(.is-landscape) {
    video {
      width: auto !important;
      height: 100%;
    }
  }
`;
const HoverAnimeLayer = styled.div<Pick<ImgMaskProps, 'isCover'>>`
  transition: ${baseTransitionSecond * 4}s ${easeOut02};
  ${mq.onlypc} {
    a:hover & {
      transform: scale3d(1.02, 1.02, 1);
      ${isIe} {
        filter: unset;
      }
    }
  }
  ${props =>
    props.isCover &&
    `
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      & > div {
        position: absolute !important;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    `}
`;

export const ImgMask: React.FC<ImgMaskProps> = props => {
  const img = useRef<HTMLDivElement>(null);
  const [isLandscape, setIsLandscape] = useState(true);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (img.current) setIsLandscape(img.current.clientHeight / img.current.clientWidth < 900 / 1440);
    }
  });
  return (
    <Container className={isLandscape ? 'is-landscape' : undefined}>
      <HoverAnimeLayer isCover={props.isCover}>
        <Img {...props} noTriggerInView />
      </HoverAnimeLayer>
    </Container>
  );
};
